import React, { FC, useMemo } from 'react'
import { ChannelContentProps } from '@app/web-player/channels/channel-content.tsx';

import { ChannelContentItem } from '@common/channels/channel.ts';
import { useExtendedInfiniteChannelContent } from '@player/custom/hooks/use-extended-infinite-channel-content.ts';

import { ChannelHeading } from '@app/web-player/channels/channel-heading.tsx';
import { useChannelContent } from '@common/channels/requests/use-channel-content.ts';

import { clsx } from 'clsx';
import { PaginationControls, PaginationControlsType } from '@common/ui/navigation/pagination-controls.tsx';

import { TagItem, ExtendTag } from '@player/custom/TagItem.tsx';
import { InfiniteScrollSentinel } from '@common/ui/infinite-scroll/infinite-scroll-sentinel';

import { useSearchParams } from 'react-router';

// @ts-ignore
export const ChannelTagsList: FC<ChannelContentProps<ChannelContentItem<ExtendTag>>> = (props) => {
    const isInfinite = useMemo(() => {
        return !props.isNested &&
            (!props.channel.config.paginationType ||
                props.channel.config.paginationType === 'infiniteScroll')
    }, [props.isNested, props.channel.config.paginationType])

    return (
        <>
            <ChannelHeading {...props} />

            {isInfinite ? (
                <InfiniteChannelTagsList {...props} />
            ) : (
                <PaginatedTagsList {...props} />
            )}
        </>
    )
}

// @ts-ignore
export const InfiniteChannelTagsList: FC<ChannelContentProps<ChannelContentItem<ExtendTag>>> = (props) => {
    const [searchParams] = useSearchParams()

    const query = useExtendedInfiniteChannelContent<ChannelContentItem<ExtendTag>>(props.channel, {
        query: searchParams.get('query') || ''
    })

    return (
        <>
            {(query.items || [])?.map(item => (
                <TagItem
                    {...item}
                    key={item.id}
                />
            ))}

            {query && <InfiniteScrollSentinel query={query} />}
        </>
    )
}

// @ts-ignore
export const PaginatedTagsList = (props: ChannelContentProps<ChannelContentItem<ExtendTag>>) => {
    const [searchParams] = useSearchParams()

    const query = useChannelContent<ChannelContentItem<ExtendTag>>(props.channel, {
        query: searchParams.get('query') || ''
    }, {
        isNested: props.isNested,
    })
    return (
        <>
            <div
                className={clsx(
                    'transition-opacity',
                    query.isPlaceholderData && 'opacity-70',
                )}
            >
                {(query.data?.data || [])?.map(item => (
                    <TagItem
                        {...item}
                        key={item.id}
                    />
                ))}

                {!props.isNested && (
                    <PaginationControls
                        pagination={query.data}
                        type={props.channel.config.paginationType as PaginationControlsType}
                        className="mt-24"
                        scrollToTop
                    />
                )}
            </div>
        </>
    )
}
